
// Логотип на стр. авторизации
import logo from './logoAuthPage.svg'

// Фоновая картинка на стр. авторизации, стать клиентом
import bgAuth from './auth-bg.jpg'

// Ссылка у кнопки Веб-сайт Постачальника 
export const SITE_LINK = 'https://tviy.energy/'

// Название поставщика (ключ для перевода из файла локализации)
export const NAME_PROVIDER = 'ТОВ «ТВІЙ ЕНЕРГОПОСТАЧАЛЬНИК»'
export const CRUMB_MAIN_TEXT = 'StrumCo'

export { logo as AUTH_LOGO }
export { bgAuth as AUTH_BG_BODY }
